// OpenerPreviewOverlay — renders the active preset inside the Studio
// phone mockup. Absolute-positioned to fill the mockup container (NOT
// fixed). Different from the public OpenerOverlay which is fixed +
// device-viewport sized.

import React from 'react';
import OpenerHost from '../../openers/OpenerHost';
import { useOpenerDraft } from './OpenerDraftContext';

export default function OpenerPreviewOverlay() {
  const draft = useOpenerDraft();
  if (!draft) return null;
  const { presetId, draftSettings, replayKey, enabled, hasSavedOpener } = draft;
  if (!presetId) return null;
  // Phase 1.9.1 — Studio preview matches public render. The overlay is
  // visible only when the opener is actively enabled (saved AND toggled
  // on). On a fresh event with no saved opener, or when the designer
  // toggled it off, the phone mockup shows the invitation directly.
  if (!hasSavedOpener || !enabled) return null;
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        pointerEvents: 'none', // preview only — public has Skip; Studio uses panel Replay
      }}
      data-testid="studio-opener-preview"
    >
      <div style={{ width: '100%', height: '100%', pointerEvents: 'auto' }}>
        <OpenerHost
          key={`preview-${presetId}-${replayKey}`}
          presetId={presetId}
          settings={draftSettings}
          onComplete={() => { /* preview loops via Replay button; no auto */ }}
        />
      </div>
    </div>
  );
}
